module.exports = {
  landingPage: {
    mission: {
      subtitle: 'ミッション',
      '1': {
        intro: {
          '1': `タイムリミットまで100分――`,
          '2': `あなたは事件の真相に`,
          '3': `辿り着けるか`
        },
        main: {
          '1':
            'ハッカークラブの新メンバーになったあなたを待ち受けるのは、被害総額100億円の大事件！？',
          '2':
            'さらに進化した“HACKPAD（ハックパッド）”を使って、サラ達と一緒に渋谷中に仕掛けられた謎を解こう。'
        },
        note: '※第1弾を遊んでいなくてもお楽しみいただける内容です',
        button: '第1弾のあらすじ',
        modalTitle: '第1弾',
        modalInfo: `ある日、あなたの元に、「ハッカークラブ」という秘密集団のメンバーを名乗る少女から突然メッセージが届く。「私はサラ。あなたの力が必要なの。私と一緒に、渋谷の街をサイバー攻撃から守って！」
        不思議に思いつつも興味本位でハッカークラブのアジトを訪れたあなただったが、そこへ突然渋谷の街を巻き込んだ爆破予告が届く。リーダーに協力を依頼されたあなたは、“ハッカークラブのエース”サラと共に、街中に仕掛けられた爆弾の解除に挑む！`,
        modalLink: `第1弾ゲームについての開催情報はこちら`
      },
      '2': {
        intro: {
          '1': `制限時間は90分――`,
          '2': `渋谷中にしかけられた謎を解き`,
          '3': `人々を救え！`
        },
        main: {
          '1': '2019年、東京。',
          '2': `この街には、サイバー事件から人々を守る秘密組織「ハッカークラブ」がいた。`,
          '3': 'ある日、あなたのもとに謎の少女"サラ"から一通のメールが届く。',
          '4': '「私はハッカークラブのサラ。あなたの力が必要なの。',
          '5':
            'ハッカークラブの入団試験を受けてみない？」果たして、入団試験の内容とは……！？'
        }
      }
    },
    trailer: {
      subtitle: '遊び方'
    },
    faq: {
      subtitle: 'よくある質問',
      allButton: '全てのFAQはこちら'
    },
    instructions: {
      subtitle: '参加方法',
      '1': {
        title: '日時を選ぶ',
        text: '遊びたい日時を決め､右下の予約ボタンから予約！'
      },
      '2': {
        title: '予約メールを確認',
        text: 'メールを確認し、当日の持ち物や注意事項を確認！'
      },
      '3': {
        title: '渋谷でゲーム開始！',
        text: `ご自身のスマホを使いゲーム開始！
        歩きやすい服装でお越し下さい`
      }
    },
    book: {
      nextStep: '予約に進む',
      nextStepShort: '予約'
    },
    announcement: {
      title: '本ゲームの開催期間は終了しました',
      text:
        'お客様の安全管理・衛生管理を徹底の上、営業を継続させていただきます。ご予約をご検討されるお客様におかれましては、下記をご確認いただきますよう宜しくお願い申し上げます。なお、政府からの緊急事態宣言発令中に限り、既にご予約いただいたお客様への返金対応も承っております。ご希望のお客様におかれましては、直接お問い合わせいただきますようお願いいたします。',
      warnings: {
        heading: '対応方針及びお客様へのお願い',
        '1':
          '外出自粛期間中に免疫力を下げないことを目的とし、「渋谷徒歩圏内にお住まいの方を対象とした散歩コンテンツ」としてご提供させていただきます。体験内容は変わらず、渋谷を散策するAR謎解きゲームです',
        '2': '電車等をご利用のうえでのご参加はご遠慮ください',
        '3':
          '「密閉」「密集」「密接」の3密を避けるため、スタート地点として利用しておりました岡崎ビルは利用せず、お客様ご自身に遠隔スタートしていただききます',
        '4': 'マスクは必ず着用のうえ、ご参加ください',
        '5': 'ご予約は2名様まで可能です。3名様以上でのご参加は承っておりません',
        '6':
          '同一スロットに他のお客様がいらっしゃった場合、2m以上の距離を空けてください',
        '7': 'ご体調の悪い方はご参加をご遠慮ください',
        '8':
          '体験中に何かトラブル等がございましたら、LINE公式アカウントにてご連絡ください'
      },
      link: {
        calendar: '予約ページへ進む',
        contact: 'お問い合わせ',
        orders: '予約変更'
      },
      confirmed: '確認しました'
    },
    news: {
      subtitle: 'ニュース'
    },
    trial: {
      subtitle: '簡単な謎解きに挑戦！',
      question: '①②③④が示すものは？',
      placeholder: '解答を入力',
      submit: '送信',
      modals: {
        correct: {
          title: '正解！',
          '1': '正解おめでとう！',
          '2': 'さっすが私が見込んだハッカーさん！',
          '3':
            'スマホ上のボタンはキーボードを、矢印はフリック入力の方向を指し示していたんだね。',
          '4': 'つまり答えは「しぶや」……。',
          '5': '私達ハッカークラブが本拠地を構える場所のことだったんだ！',
          button: '結果を共有する'
        },
        incorrect: {
          title: '不正解',
          '1': '入力してくれた答えは',
          '2': '正解じゃなかったみたい……',
          '3':
            'どうやらスマホ上のボタンはキーボードを模しているみたいだね。矢印は……何かを動かす方向を示しているのかな？',
          '4': '君なら絶対に解けるよ！',
          '5': 'もう一度トライしてみて',
          button: 'もう一度挑戦！'
        }
      }
    },
    characters: {
      subtitle: '登場キャラクター',
      keys: {
        voice: 'CV：',
        age: '年齢',
        favorite: '好きなもの',
        job: '職業',
        skill: '特技'
      },
      sarah: {
        name: 'サラ',
        voice: '富田美憂',
        phrase: {
          '1': '「よっす、新人ハッカーさん！',
          '2': '待ってたよ。」'
        },
        bio:
          'ハッカークラブのメンバーで17歳の現役女子高生。高い技術力を持ち、メンバーからも若きエースとして信頼されている。ゲームが大好き。',
        age: '17',
        favorite: 'ゲーム',
        job: '女子高生 / ハッカークラブのエース',
        skill: 'ダンス / 歌'
      },
      leader: {
        name: 'リーダー',
        voice: '泰勇気',
        phrase: {
          '1': '「みんな、集まってくれて',
          '2': 'ありがとう。」'
        },
        bio:
          'ハッカークラブの創設者 兼 リーダー。幼少期から英才教育を受け、将来を約束されたエリートだったが、ある過去をきっかけにハッカークラブの活動を始めた。',
        age: '25',
        favorite: '歴史小説 / ビール',
        job: 'ハッカークラブのリーダー',
        skill: 'ピアノ'
      },
      offender: {
        name: '？？？',
        voice: '成澤卓',
        phrase: {
          '1': '「どうする？',
          '2': '正義の味方さん。」'
        },
        bio: '謎の人物。何かたくらんでいるようだが……？',
        age: '？？',
        favorite: '？？？',
        job: '？？？',
        skill: '？？？'
      },
      anego: {
        name: 'アネゴ',
        voice: '佐倉薫',
        phrase: {
          '1': '「こんなに大活躍されちゃ、',
          '2': '認めざるをえないよね。」'
        },
        bio:
          'ハッカークラブの古株メンバーの1人で、昼間はオフィス街を颯爽と歩くキャリアウーマン。本名や年齢などの個人情報は秘密。',
        age: '20代後半？',
        favorite: '犬 / お酒',
        job: '丸の内OL',
        skill: 'おしゃれ'
      },
      branchManager: {
        name: '？？？',
        voice: '牧野由依',
        phrase: {
          '1': '「一刻も早く、',
          '2': 'ハッキングを撃退しなさい。」'
        },
        bio: '今回の事件の依頼人。やたらと要求が多い。',
        age: '？？',
        favorite: '？？？',
        job: '？？？',
        skill: '？？？'
      }
    },
    information: {
      subtitle: '詳細情報',
      playTime: 'プレイ時間',
      playerCapacity: 'プレイ人数',
      price: '料金',
      location: {
        label: '開始地点',
        warning: '※具体的な行き先はゲーム開始後に指示がございます'
      },
      weekday: '平日',
      holiday: '休日',
      noPlayerLimit: '1人〜制限なし',
      belongings: {
        label: '持ち物',
        value: '当アプリに対応したスマートフォン'
      }
    },
    devices: {
      subtitle: '対応スマートフォン',
      rental: {
        title: 'スマホレンタルにつきまして',
        text: {
          '1':
            '店舗閉鎖に伴い、誠に勝手ながら、スマホレンタルのご案内も廃止とさせていただきます。',
          '2':
            'つきましては、原則としまして、対応端末をお持ちの方のみのご案内となりますこと、予めご了承くださいませ。',
          '3':
            '対応端末をお持ちでないお客様におかれましては、お連れ様との端末シェアにご同意いただける場合に限り、ご予約を承ることが可能です。<br/>このような場合でも、参加料につきましては、人数分をお支払い頂きますようお願いいたします。'
        }
      }
    },
    warning: {
      subtitle: '注意事項',
      '1': 'アプリの通知と位置情報は許可してください',
      '2': '遊ぶ前は十分スマホを充電してきてください',
      '3': 'ゲーム中のアプリ切替え・画面オフはできません',
      '4': '遊んだ後はネタバレはご遠慮下さい',
      '5': '街の人にゲームのことを聞かないでください',
      '6': '人にぶつかると危ないので、走らないでください',
      '7': '歩きスマホはご遠慮下さい',
      '8': '集団で道路にたまったりしないでください',
      '9': 'キャッチについていかないでください',
      '10': '地図にない建物はゲームをプレイする上で考慮する必要はありません',
      '11': '写真撮影は人が映りこまないようにお願いします',
      '12': '歩きやすい靴でお越しください'
    },
    footer: {
      terms: '利用規約',
      disclaimer: '免責事項',
      company: 'お仕事のご相談はこちら',
      policy: 'プライバシーポリシー',
      salesNotice: '特定商取引法に基づく表記',
      contact: 'お問い合わせ',
      answer: '動画の謎の答え',
      copyright: {
        '1': '© 2019-2020 Pretia Technologies, Inc.',
        '2': '© 2018-2020 Pretia Technologies, Inc.'
      }
    }
  }
};
